import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=58d77173&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&lang=css"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=58d77173&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d77173",
  null
  
)

export default component.exports